// External imports
import { Sparkles, BookOpen, TrendingUp, Award } from "lucide-react";

export default function Introduction() {
  return (
    <section className="bg-gradient-to-b from-gray-100 to-gray-50 py-8 md:py-16 px-4 sm:px-6 lg:px-8 rounded-xl">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-12 flex flex-col gap-y-4 md:gap-y-2">
          <h2 className="text-2xl font-extrabold md:text-4xl">
            Introducing{" "}
            <q className="block md:inline text-3xl md:text-4xl text-primary">
              Genie Says
            </q>
          </h2>
          <p className="mt-2 md:text-xl">Your AI-Powered Transcript Synopsis</p>
        </div>

        <div className="bg-white rounded-lg shadow-xl p-5 md:p-8 flex flex-col gap-y-4">
          <p className="md:text-lg text-gray-700 mb-8">
            {` Let `}
            <strong>&ldquo;Genie Says&rdquo;</strong>
            {` do the heavy lifting! Our AI doesn't just convert grades — it also provides a concise, insightful synopsis of each transcript, highlighting key academic achievements, patterns, and areas of strength. With `}
            <em>Genie Says</em>
            {`, you get a quick, comprehensive overview at a glance, making it easier to evaluate applicants beyond just the numbers.`}
          </p>

          <h2 className="text-2xl font-bold text-[#0072bc] mb-4">
            Revolutionize Your Admissions Process
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <FeatureCard
              icon={<Sparkles className="size-5 md:size-6 text-primary" />}
              title="AI-Powered Insights"
              description="Harness the power of AI to extract meaningful insights from transcripts."
            />
            <FeatureCard
              icon={<BookOpen className="size-5 md:size-6 text-primary" />}
              title="Comprehensive Overview"
              description="Get a quick, yet thorough understanding of each applicant's academic profile."
            />
            <FeatureCard
              icon={<TrendingUp className="size-5 md:size-6 text-primary" />}
              title="Identify Patterns"
              description="Spot trends and patterns in academic performance with ease."
            />
            <FeatureCard
              icon={<Award className="size-5 md:size-6 text-primary" />}
              title="Highlight Strengths"
              description="Easily identify and focus on each applicant's areas of excellence."
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function FeatureCard({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) {
  return (
    <div className="flex items-start space-x-4">
      <div className="flex-shrink-0">
        <div className="bg-gray-200 rounded-full p-2 md:p-3">{icon}</div>
      </div>
      <div>
        <h3 className="md:text-lg font-medium text-gray-900">{title}</h3>
        <p className="mt-2 text-sm text-gray-500">{description}</p>
      </div>
    </div>
  );
}
